module.exports = __webpack_public_path__ + "img/Rettungshund.f03df648.svg";